// extracted by mini-css-extract-plugin
export default {"wrap":"main-wrap_EWTrH","canvasWrap":"main-canvasWrap_nbbMO","canvas":"main-canvas_gh1Ox","toolbar":"main-toolbar_B0Zhr"};